
import {createSlice} from "@reduxjs/toolkit"

const initialStateValue = []

export const JobSlice = createSlice({
    name: "Job",
    initialState:{ value:initialStateValue},
    reducers: {
        setJob:(state, action)=> {
            state.value = action.payload
        },
        clearJob:(state)=>{
            state.value = initialStateValue
        }
    }
})

export default JobSlice.reducer;

export const {setJob, clearJob} =  JobSlice.actions